export const GATSBY_CLOUD = process.env.GATSBY_CLOUD;
export const GATSBY_ASSET_PREFIX = process.env.GATSBY_ASSET_PREFIX;
